import type { FC } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { usePopover } from "src/hooks/use-popover";

import { LanguagePopover } from "./language-popover";
import { Typography } from "@mui/material";

export type Language = "en" | "nl";

const languages: Record<Language, string> = {
  // en: "/assets/flags/flag-uk.svg",
  // nl: "/assets/flags/flag-nl.svg",
  en: "EN",
  nl: "NL",
};

export const LanguageSwitch: FC = () => {
  const { i18n } = useTranslation();
  const popover = usePopover<HTMLButtonElement>();
  const languageCode = (i18n.language || "en").split("-")[0] as Language;
  const flag = languages[languageCode] ?? languageCode.toUpperCase();
  return (
    <>
      <Tooltip title="Language">
        <IconButton onClick={popover.handleOpen} ref={popover.anchorRef}>
          <Box
            sx={{
              width: 28,
              "& img": {
                width: "100%",
              },
            }}
          >
            <Typography variant="h6" sx={{}}>
              {flag}
            </Typography>
            {/* <img src={flag} /> */}
          </Box>
        </IconButton>
      </Tooltip>
      <LanguagePopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
